export default "__VITE_ASSET__Denvw6_l__"